import React from 'react';
// import { navigate } from 'gatsby';
import { Button, Flex, SxStyleProp } from '@tishman/components';
import { navigate } from 'gatsby';

import { useLocalizedLink } from '../../../../utils/use-localized-link';
import { useAppSelector } from '../../../../store';
import { selectFlow } from '../../../../store/selectors/order';
import { isRinkOrRinkMembershipRelated } from '../../../../services/viva/utils/is-rink-or-rink-membership-related';
import { newRelic } from '../../../../utils/new-relic';

const buttonStyles: SxStyleProp<'buttons'> = {
  height: '58px',
  py: [0],
};

export const CartFooter = () => {
  const getLocalizedLink = useLocalizedLink();
  const flow = useAppSelector(selectFlow);

  const upSellTicketMessage = () => {
    const defaultMessage = isRinkOrRinkMembershipRelated(flow)
      ? 'Add Top of the Rock Tickets'
      : 'Add Rink Tickets';

    return defaultMessage;
  };

  return (
    <Flex
      sx={{
        flex: ['1 0 230px', '1 0 262px'],
        flexDirection: 'column',
        rowGap: ['12px'],
        backgroundColor: '#89CBDB',
        px: ['16px'],
        py: ['24px'],
      }}
    >
      <Button
        className="view-checkout"
        data-gtm-initiator="modal"
        data-testid="checkout-button-cart-footer"
        onClick={() => {
          newRelic.logCartAction(
            'Modal CartFooter - (go to) Checkout',
            'onClick',
          );
          navigate(getLocalizedLink('/checkout/'));
        }}
        sx={buttonStyles}
        variant="inverted"
      >
        Check Out
      </Button>
      <Button
        className="view-cart"
        data-gtm-initiator="modal"
        data-testid="view-cart-button-cart-footer"
        onClick={() => {
          newRelic.logCartAction('Modal CartFooter - View Cart', 'onClick');
          navigate(getLocalizedLink('/cart/'));
        }}
        sx={{
          ...buttonStyles,
          backgroundColor: 'white',
        }}
        variant="primary"
      >
        View Cart
      </Button>
      {/* This upsell button has been temporarily removed b/c the Rink is out of season */}
      {/* <Button
        data-gtm-trigger="add-more-tickets"
        onClick={() =>
          (window.location.href = `${getLocalizedLink(
            '/buy-tickets',
          )}${getHashFromFlow()}`)
        }
        sx={{
          alignSelf: 'center',
          backgroundColor: 'transparent',
          fontFamily: 'body',
          letterSpacing: '1px',
          fontWeight: 500,
        }}
        variant="underline"
      >
        {upSellTicketMessage()}
      </Button> */}
    </Flex>
  );
};
